export const category = [
  {
    categoryId: 0,
    categoryName: "Dashboard",
    categoryKey: "Permissions.WebPermissions.Dashboard",
    subcategories: [
      {
        subcategoryId: 0,
        subcategoryName: "Dashboard",
        categoryKey: "Permissions.WebPermissions.Dashboard",
        items: [
          {
            id: 1,
            title: "Dashboard",
            categoryKey: "Permissions.WebPermissions.Dashboard.Dashboard",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
                videoUrl:
                  "https://productionagaas.blob.core.windows.net/a1gaas-prod-drill1/93659078-b959-421a-9184-9a26485e363b/JobBookingTutorial/Finance/Car Look Up/ae512280-b840-45a6-999e-34fe200544a5.mp4",
              },
              {
                title: "Thumbnail 8",
                url: "https://www.veeforu.com/wp-content/uploads/2022/10/red-gaming-thumbnail-download.jpg",
                videoUrl:
                  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
              },
            ],
          },
        ],
      },
    ],
  },
  // {
  //   categoryId: 1,
  //   categoryName: "Auto Parts",
  //   categoryKey: "Permissions.WebPermissions.AutoParts",
  //   subcategories: [
  //     {
  //       subcategoryId: 1,
  //       subcategoryName: "Stock Records",
  //       categoryKey: "Permissions.WebPermissions.AutoParts",
  //       items: [
  //         {
  //           id: 2,
  //           title: "Stock Records",
  //           categoryKey: "Permissions.WebPermissions.AutoParts.StockRecords",
  //           thumbnails: [
  //             {
  //               title: "Thumbnail 1",
  //               url: "https://www.veeforu.com/wp-content/uploads/2022/10/red-gaming-thumbnail-download.jpg",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 2",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
  //             },
  //             {
  //               title: "Thumbnail 3",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 4",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 5",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 6",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 7",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 8",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 9",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 10",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
  //             },
  //             {
  //               title: "Thumbnail 11",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 12",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 13",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //             {
  //               title: "Thumbnail 14",
  //               url: "https://via.placeholder.com/150",
  //               videoUrl:
  //                 "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  //             },
  //           ],
  //         },
  //         {
  //           id: 3,
  //           title: "Import A.P. Records",
  //           categoryKey: "Permissions.WebPermissions.AutoParts.ImportAPRecords",
  //           thumbnails: [
  //             {
  //               title: "Thumbnail 3",
  //               url: "https://i.pinimg.com/736x/ed/93/6f/ed936fa3053731b50c0af7a8018453ee.jpg",
  //             },
  //             {
  //               title: "Thumbnail 4",
  //               url: "https://via.placeholder.com/150",
  //             },
  //           ],
  //         },
  //         {
  //           id: 4,
  //           title: "A.P. Branches",
  //           categoryKey: "Permissions.WebPermissions.AutoParts.APBranches",
  //           thumbnails: [
  //             {
  //               title: "Thumbnail 3",
  //               url: "https://i.pinimg.com/736x/ed/93/6f/ed936fa3053731b50c0af7a8018453ee.jpg",
  //             },
  //             {
  //               title: "Thumbnail 4",
  //               url: "https://via.placeholder.com/150",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   categoryId: 2,
  //   categoryName: "Finance",
  //   categoryKey: "Permissions.WebPermissions.Finance",
  //   subcategories: [
  //     {
  //       subcategoryId: 2,
  //       subcategoryName: "Car Look Up",
  //       categoryKey: "Permissions.WebPermissions.Finance",
  //       items: [
  //         {
  //           id: 5,
  //           title: "Car Look Up",
  //           categoryKey: "Permissions.WebPermissions.Finance.CarLookUp",
  //           thumbnails: [
  //             {
  //               title: "Thumbnail 7",
  //               url: "https://via.placeholder.com/150",
  //             },
  //             {
  //               title: "Thumbnail 8",
  //               url: "https://via.placeholder.com/150",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    categoryId: 3,
    categoryName: "Inventory",
    categoryKey: "Permissions.WebPermissions.Inventories",
    subcategories: [
      {
        subcategoryId: 3,
        subcategoryName: "Inventory",
        categoryKey: "Permissions.WebPermissions.Inventories",
        items: [
          // {
          //   id: 6,
          //   title: "Inventory",
          //   categoryKey: "Permissions.WebPermissions.Inventories.InStock",
          //   thumbnails: [
          //     {
          //       title: "Thumbnail 7",
          //       url: "https://via.placeholder.com/150",
          //     },
          //     {
          //       title: "Thumbnail 8",
          //       url: "https://via.placeholder.com/150",
          //     },
          //   ],
          // },
          {
            id: 73,
            title: "In Stock",
            categoryKey: "Permissions.WebPermissions.Inventories.InStock",
            actions: true,
          },
          {
            id: 59,
            title: "Catalyst Converter",
            categoryKey:
              "Permissions.WebPermissions.Inventories.CatalystConverter",
            actions: true,
          },
          // {
          //   id: 60,
          //   title: "Scrap Metal Type",
          //   categoryKey:
          //     "Permissions.WebPermissions.Inventories.ScrapMetalType",
          //   actions: true,
          // },
          {
            id: 61,
            title: "Scrap Metal Trips",
            categoryKey:
              "Permissions.WebPermissions.Inventories.ScrapMetalTripListing",
            actions: true,
          },{
            id: 69,
            title: "Scrap",
            categoryKey:
              "Permissions.WebPermissions.Inventories.ScrapMetalTripListing",
            actions: true,
          },
          // {
          //   id: 62,
          //   title: "Scrap Body Disposal",
          //   categoryKey:
          //     "Permissions.WebPermissions.Inventories.ScrapBodyDisposalListing",
          //   actions: true,
          // },
          // {
          //   id: 63,
          //   title: "Shipping Containers",
          //   categoryKey:
          //     "Permissions.WebPermissions.Inventories.ShippingContainerListing",
          //   actions: true,
          // },
          {
            id: 64,
            title: "Container Packing",
            categoryKey:
              "Permissions.WebPermissions.Inventories.ContainerPackingTab",
            actions: true,
          },
          // {
          //   id: 65,
          //   title: "Dismantled Jobs",
          //   categoryKey: "Permissions.WebPermissions.Inventories.DismantledJob",
          //   actions: true,
          // },
          {
            id: 66,
            title: "Dismantled Parts",
            categoryKey:
              "Permissions.WebPermissions.Inventories.DismantledPart",
            actions: true,
          },
          // {
          //   id: 67,
          //   title: "Sold To Parts",
          //   categoryKey: "Permissions.WebPermissions.Inventories.SoldToParts",
          //   actions: true,
          // },
          // {
          //   id: 68,
          //   title: "Complete Car Sold",
          //   categoryKey:
          //     "Permissions.WebPermissions.Inventories.CompleteCarSold",
          //   actions: true,
          // },
        ],
      },
    ],
  },
  {
    categoryId: 4,
    categoryName: "Job Bookings",
    categoryKey: "Permissions.WebPermissions.JobBookings",
    subcategories: [
      {
        subcategoryId: 4,
        subcategoryName: "Job Bookings",
        categoryKey: "Permissions.WebPermissions.JobBookings",
        items: [
          {
            id: 7,
            title: "All cars",
            categoryKey: "Permissions.WebPermissions.JobBookings.AllCar",
            thumbnails: [],
          },
          {
            id: 8,
            title: "Tow Records",
            categoryKey: "Permissions.WebPermissions.JobBookings.TowRecords",
            thumbnails: [],
          },
          {
            id: 9,
            title: "Auctions",
            categoryKey: "Permissions.WebPermissions.JobBookings.Auction",
            thumbnails: [],
          },
          {
            id: 10,
            title: "Jobs",
            categoryKey: "Permissions.WebPermissions.JobBookings.Job",
            thumbnails: [],
          },
          {
            id: 11,
            title: "Jobs (Basic)",
            categoryKey: "Permissions.WebPermissions.JobBookings.BasicJob",
            thumbnails: [],
          },
          {
            id: 12,
            title: "Quotes",
            categoryKey: "Permissions.WebPermissions.JobBookings.Quote",
            thumbnails: [],
          },
          {
            id: 13,
            title: "Locked Jobs",
            categoryKey: "Permissions.WebPermissions.JobBookings.LockedJobs",
            thumbnails: [],
          },
          // {
          //   id: 14,
          //   title: "Office Drop-Offs",
          //   categoryKey: "Permissions.WebPermissions.JobBookings.OfficeDropOff",
          //   thumbnails: [],
          // },
          {
            id: 15,
            title: "Ppsr Lockups",
            categoryKey: "Permissions.WebPermissions.JobBookings.Ppsr",
            thumbnails: [],
          },
          // {
          //   id: 16,
          //   title: "Unresolved Jobs",
          //   categoryKey:
          //     "Permissions.WebPermissions.JobBookings.Quote.UnresolvedJob",
          //   thumbnails: [
          //     {
          //       title: "Thumbnail 7",
          //       url: "https://via.placeholder.com/150",
          //     },
          //   ],
          // },
          {
            id: 17,
            title: "Vin/Rego Decoder",
            categoryKey:
              "Permissions.WebPermissions.JobBookings.VinRegoDecoderUi",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 18,
            title: "Website Enquiries",
            categoryKey:
              "Permissions.WebPermissions.JobBookings.WebsiteInquiry",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 19,
            title: "Inquiry System",
            categoryKey: "Permissions.WebPermissions.JobBookings.InquirySystem",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 20,
            title: "Car Referral",
            categoryKey: "Permissions.WebPermissions.JobBookings.CarReferral",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 21,
            title: "Stolen Vehicle",
            categoryKey: "Permissions.WebPermissions.JobBookings.Stolen",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 5,
    categoryName: "Off. Inventory",
    categoryKey: "Permissions.WebPermissions.OffshoreInventories",
    subcategories: [
      {
        subcategoryId: 5,
        subcategoryName: "Off. Inventory",
        categoryKey: "Permissions.WebPermissions.OffshoreInventories",
        items: [
          {
            id: 22,
            title: "Con. Exp. Type",
            categoryKey:
              "Permissions.WebPermissions.OffshoreInventories.OffshoreContainerExpenseType",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 23,
            title: "Off. Customers",
            categoryKey:
              "Permissions.WebPermissions.OffshoreInventories.OffshoreCustomer",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 24,
            title: "Off. Sales",
            categoryKey:
              "Permissions.WebPermissions.OffshoreInventories.OffshoreSales",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 25,
            title: "Cust. Statement",
            categoryKey:
              "Permissions.WebPermissions.OffshoreInventories.OffshoreCustomerStatement",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 26,
            title: "Bulk Payment",
            categoryKey:
              "Permissions.WebPermissions.OffshoreInventories.OffshoreBulkPayment",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 27,
            title: "Cash Flow",
            categoryKey:
              "Permissions.WebPermissions.OffshoreInventories.OffshoreCashFlow",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          // {
          //   id: 28,
          //   title: "Offshore Storage",
          //   categoryKey:
          //     "Permissions.WebPermissions.OffshoreInventories.OffshoreInventoryListing",
          //   thumbnails: [
          //     {
          //       title: "Thumbnail 7",
          //       url: "https://via.placeholder.com/150",
          //     },
          //   ],
          // },
        ],
      },
    ],
  },
  {
    categoryId: 6,
    categoryName: "Reports",
    categoryKey: "Permissions.WebPermissions.Reports",
    subcategories: [
      {
        subcategoryId: 6,
        subcategoryName: "Reports",
        categoryKey: "Permissions.WebPermissions.Reports",
        items: [
          {
            id: 29,
            title: "Form 1",
            categoryKey: "Permissions.WebPermissions.Reports.Form1",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 30,
            title: "Form 3A",
            categoryKey: "Permissions.WebPermissions.Reports.Form3A",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 31,
            title: "Form 5",
            categoryKey: "Permissions.WebPermissions.Reports.Form5",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 32,
            title: "Form 6",
            categoryKey: "Permissions.WebPermissions.Reports.Form6",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 33,
            title: "Job Status",
            categoryKey: "Permissions.WebPermissions.Reports.JobStatus",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          // {
          //   id: 34,
          //   title: "Non-Accidental Towing Record",
          //   categoryKey:
          //     "Permissions.WebPermissions.Reports.NonAccidentalTowingRecord",
          //   thumbnails: [
          //     {
          //       title: "Thumbnail 7",
          //       url: "https://via.placeholder.com/150",
          //     },
          //   ],
          // },
        ],
      },
    ],
  },
  {
    categoryId: 7,
    categoryName: "Scrap Metal Collection",
    categoryKey: "Permissions.WebPermissions.OutsideScrapMetalCollections",
    subcategories: [
      {
        subcategoryId: 7,
        subcategoryName: "Scrap Metal Collection",
        categoryKey: "Permissions.WebPermissions.OutsideScrapMetalCollections",
        items: [
          {
            id: 35,
            title: "Truck Loads",
            categoryKey:
              "Permissions.WebPermissions.OutsideScrapMetalCollections.TruckLoad",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 36,
            title: "Outside Customer",
            categoryKey:
              "Permissions.WebPermissions.OutsideScrapMetalCollections.OutsideCustomer",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 8,
    categoryName: "Settings",
    categoryKey: "Permissions.WebPermissions.Settings",
    subcategories: [
      {
        subcategoryId: 8,
        subcategoryName: "Settings",
        categoryKey: "Permissions.WebPermissions.Settings",
        items: [
          {
            id: 37,
            title: "Account Manager",
            categoryKey: "Permissions.WebPermissions.Settings.AccountManager",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 38,
            title: "Auto Parts",
            categoryKey: "Permissions.WebPermissions.Settings.AutoPart",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 39,
            title: "Branch Offices",
            categoryKey: "Permissions.WebPermissions.Settings.BranchOffice",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 40,
            title: "Clients",
            categoryKey: "Permissions.WebPermissions.Settings.Client",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 41,
            title: "Assessors",
            categoryKey: "Permissions.WebPermissions.Settings.Assessors",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 42,
            title: "Dismantle Types",
            categoryKey: "Permissions.WebPermissions.Settings.DismantleType",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 43,
            title: "Driver Truck Assignment",
            categoryKey:
              "Permissions.WebPermissions.Settings.DriverTruckAssignment",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 44,
            title: "Scrap Metal Type",
            categoryKey: "Permissions.WebPermissions.Settings.ScrapMetalType",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 45,
            title: "Service Areas",
            categoryKey: "Permissions.WebPermissions.Settings.ServiceArea",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          // {
          //   id: 46,
          //   title: "LogIn Register",
          //   categoryKey: "Permissions.WebPermissions.Settings.LogInRegister",
          //   thumbnails: [
          //     {
          //       title: "Thumbnail 7",
          //       url: "https://via.placeholder.com/150",
          //     },
          //   ],
          // },
          {
            id: 47,
            title: "Offshore Branch",
            categoryKey:
              "Permissions.WebPermissions.Settings.OffshoreBranchOffice",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 48,
            title: "Trucks",
            categoryKey: "Permissions.WebPermissions.Settings.Truck",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 49,
            title: "Lead Source",
            categoryKey: "Permissions.WebPermissions.Settings.LeadSource",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 50,
            title: "Communication",
            categoryKey: "Permissions.WebPermissions.Settings.Communication",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          // {
          //   id: 51,
          //   title: "Vehicle Parts Criteria",
          //   categoryKey:
          //     "Permissions.WebPermissions.Settings.VehiclePartsCriteria",
          //   thumbnails: [
          //     {
          //       title: "Thumbnail 7",
          //       url: "https://via.placeholder.com/150",
          //     },
          //   ],
          // },
          {
            id: 52,
            title: "Quote Rejected",
            categoryKey: "Permissions.WebPermissions.Settings.QuoteRejected",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 53,
            title: "Referee",
            categoryKey: "Permissions.WebPermissions.Settings.Referee",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 54,
            title: "Change Logs",
            categoryKey: "Permissions.WebPermissions.Settings.ChangeLogs",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 55,
            title: "RedBook Car Makes",
            categoryKey: "Permissions.WebPermissions.Settings.CarMake",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 56,
            title: "Car Parts List",
            categoryKey: "Permissions.WebPermissions.Settings.CarPartsList",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          // {
          //   id: 57,
          //   title: "Car Pricing Setting",
          //   categoryKey:
          //     "Permissions.WebPermissions.Settings.CarPricingSetting",
          //   thumbnails: [
          //     {
          //       title: "Thumbnail 7",
          //       url: "https://via.placeholder.com/150",
          //     },
          //     {
          //       title: "Thumbnail 8",
          //       url: "https://via.placeholder.com/150",
          //     },
          //   ],
          // },
          // {
          //   id: 58,
          //   title: "Car Inquiry Setting",
          //   categoryKey:
          //     "Permissions.WebPermissions.Settings.CarInquirySetting",
          //   thumbnails: [],
          // },
          // {
          //   id: 69,
          //   title: "Role Manager",
          //   categoryKey: "Permissions.WebPermissions.Settings.RoleManager",
          //   actions: true,
          // },
          // {
          //   id: 70,
          //   title: "Client Type",
          //   categoryKey: "Permissions.WebPermissions.Settings.ClientType",
          //   actions: true,
          // },
          // {
          //   id: 71,
          //   title: "External API Logs",
          //   categoryKey: "Permissions.WebPermissions.Settings.ExternalApiLogs",
          //   actions: true,
          // },
          // {
          //   id: 72,
          //   title: "Offshore Branch Office",
          //   categoryKey:
          //     "Permissions.WebPermissions.Settings.OffshoreBranchOffice",
          //   actions: true,
          // },
        ],
      },
    ],
  },
];
